/* globals twemoji  */

import Vue from 'vue';
const reverse = s => s.split('').reverse().join('');
import {DateTime} from 'luxon';

const TAP_LINK_PATTERN = /^tap:\/\/[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}/

const tokens = {
  word: Vue.component('word', {
    render: function (createElement) {
      return createElement('span',
                           {
                             class: {
                               [this.type ]: true
                             },
                             domProps: {
                               innerHTML: twemoji.parse(this.token),
                             },
      })
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  pin: Vue.component('pin', {
    render: function (createElement) {

      return createElement(
        'span',
        {
          class: {
            [this.type + '-token']: true
          },
          domProps: {
            innerHTML: '*' + (this.chunk.value === '0' ? '' : this.chunk.value),
          },
        },
      )
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  path: Vue.component('f', {
    render: function (createElement) {
      return createElement(
        'span',
        {
          on: {
            click: () => {
              const page = this.$route.name === 'landing' ? 'notes' : this.$route.name;

              this.$nav(page, {folder: (this.$route.params.path || '') +
                                       reverse(reverse(this.token.replace(/"(?!\\)/g, '')))})
            }
          },
          class: {
            'cursor-pointer': true,
            'path': true
          },
          domProps: {
            innerHTML: twemoji.parse(reverse(reverse(this.token.replace(/"(?!\\)/g, '')))),
          },
        }
      )
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  folder: Vue.component('folder', {
    render: function (createElement) {
      
      const content = twemoji.parse(this.chunk.value.split(('/' + this.$route.params.path).replace(/\/$/, '')).join(''));

      if (content) {
        return createElement(
          'span',
          [createElement('span',

                         {
                           on: {
                             click: () => {
                               const page = this.$route.name === 'landing' ? 'notes' : this.$route.name;

                               this.$nav(page, {folder: this.chunk.value})
                             }
                           },
                           class: {
                             'cursor-pointer': true,
                             'path': true
                           },
                           domProps: {
                             innerHTML: content,
                           },
          })],
        )
      } else {
        return null
      }
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  // TODO
  todo: Vue.component('todo', {
    render: function (createElement) {

      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: twemoji.parse(this.token),
          }
      })
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  // DONE
  done: Vue.component('done', {
    render: function (createElement) {

      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: twemoji.parse(this.token),
          }
        },
        this.token)
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  // TAG
  tag: Vue.component('tag', {
    render: function (createElement) {

      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: twemoji.parse(this.token),
          },
          
        },
      )
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),


  // URL
  url: Vue.component('url', {
    render: function (createElement) {
      return createElement('a',
                           {
                             class: {
                               [this.type]: true
                             },
                             attrs: {
                               href: this.token,
                               target: '_blank'
                             },
                             domProps: {
                               innerHTML: twemoji.parse(this.url ? this.url.title || this.url.href : this.token),
                             }
                           },
                           )
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      url: {
        type: Object
      }
    },
  }),


  // Link
  link: Vue.component('sowhat-link', {
    render: function (createElement) {

      const val = this.chunk.value

      let link;

      let img;
      if (val['img-src']) {
        const src = TAP_LINK_PATTERN.test(val['img-src']) ? val['img-src'].replace(/^tap:\/\//, `${process.env.VUE_APP_API_URL}/messages/upload/`) : val['img-src']

        img = createElement('img', {
          domProps: {
            src,
            alt: val['img-title']
        }})
      }

      if (val.href) {
        const href = TAP_LINK_PATTERN.test(val.href) ? val.href.replace(/^tap:\/\//, `${process.env.VUE_APP_API_URL}/messages/upload/`) : val.href

        link = createElement('a', {
          domProps: {
            href
          }
        }, [img || val.title])
      } else {
        link = img
      }

      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            
          }
      }, [link])
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  // BANG
  bang: Vue.component('bang', {
    render: function (createElement) {
      return createElement('span',
                           {
                             class: {
                               bang: true
                             },
                             domProps: {
                               innerHTML: twemoji.parse(this.token),
                             }
                           },
                           this.token)
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  event: Vue.component('event', {
    render: function (createElement) {
      return createElement('span',
                           {
                             class: {
                               bang: true
                             },
                             domProps: {
                               innerHTML: twemoji.parse(this.token) + ' at ' +
                                          DateTime.fromISO(this.date).toFormat('LLL dd, yyyy t'),
                             }
                           },
                           this.token)
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      date: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  formula: Vue.component('formula', {
    render: function (createElement) {
      const name = this.formula.name ?  this.formula.name + ': ' : ''

      const content = typeof this.formula.result === 'object' ?

                      this.formula.result.type === 'IMAGE' ?
                      createElement('img', {domProps: {
                        src: this.formula.result.data.src, alt: this.formula.result.data.title}})
                    : createElement('span', twemoji.parse(name) + ' ERROR: ' + this.formula.result.error.message)
                    : createElement('span', twemoji.parse(name) + this.formula.result)

      return createElement('span',
                           {
                             children: content,
                             class: {
                               formula: true
                             },
                             /* domProps: {
                              *   innerHTML: content
                              * } */
                           }, [content])
    },
    props: {
      chunk: {
        type: Object
      },
      formula: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),


  date: Vue.component('date', {
    render: function (createElement) {
      return createElement('span',
                           {
                             class: {
                               date: true
                             },
                             domProps: {
                               innerHTML: DateTime.fromISO(this.token).toFormat('LLL dd, yyyy t'),
                             }
                           },
                           this.token)
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),


  bean: Vue.component('bean', {
    render: function (createElement) {
      return createElement('span',
                           {
                             class: {
                               plus: this.chunk.value.sign == '+',
                               minus: this.chunk.value.sign == '-' 
                             },
                             domProps: {
                               innerHTML: this.chunk.value.sign + ' ' +
                                          twemoji.parse(this.chunk.value.symbol) +
                                          ': ' +
                                          this.chunk.value.value,
                             }
                           },
                           this.token)
    },
    props: {
      chunk: {
        type: Object
      },
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  // PLUS
  plus: Vue.component('plus', {
    render: function (createElement) {
      return createElement('span',
                           {
                             class: {
                               [this.type]: true
                             },
                             domProps: {
                               innerHTML: twemoji.parse(this.token),
                             }
                           },
                           this.token)
    },
    props: {
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),


  

  // MINUS
  minus: Vue.component('minus', {
    render: function (createElement) {
      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: twemoji.parse(this.token),
          }
        },
        );
    },
    props: {
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  lparen: Vue.component('lparen', {
    render: function (createElement) {
      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: this.token,
          }
        },
        );
    },
    props: {
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  rparen: Vue.component('rparen', {
    render: function (createElement) {
      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: this.token,
          }
        },
        );
    },
    props: {
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  operator: Vue.component('operator', {
    render: function (createElement) {
      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: twemoji.parse(this.token),
          }
        },
        this.token);
    },
    props: {
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  arg: Vue.component('arg', {
    render: function (createElement) {
      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: twemoji.parse(this.token),
          }
        },
        this.token);
    },
    props: {
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),

  error: Vue.component('error', {
    render: function (createElement) {
      return createElement(
        'span',
        {
          class: {
            [this.type]: true
          },
          domProps: {
            innerHTML: twemoji.parse(this.token),
          }
        },
        this.token);
    },
    props: {
      token: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  }),
}

export default Vue.component('note', {
  render: function (createElement) {
    const nodes = [];

    const chunks = [].concat(this.item && this.item.parsed && this.item.parsed.chunks ? this.item.parsed.chunks : [])

    if (chunks.length) {
      chunks.forEach((chunk, i) => {
        /* NOTE: this is used if we include block level elements
           if (['date', 'folder', 'formula', 'bean', 'event'].indexOf(chunk.type) !== -1) {
         *   if (chunks[i + 1] && chunks[i + 1].type === 'space') {
         *     chunks.splice(i + 1, 1)
         *   }
         * } */
        let j = i + 1;
        if (chunk.type === 'folder') {
          let text = chunk.text
          while (j < chunks.length && chunks[j].type === 'folder') {
            text += chunks[j.text]
            chunk = {
              ...chunk,
              text: chunk.text + chunks[j].text,
              value: chunk.value + chunks[j].value
            }

            chunks.splice(j, 1);
          }
        }

        const elm = tokens[chunk.type] || 'span';
        const props = { token: chunk.text, type:chunk.type, chunk }

        if (chunk.type === 'formula') {
          props.formula = this.item.formulas.find(f => f.text === chunk.text)
        } else if (chunk.type === 'event') {
          props.date = this.item.date
        } else if (chunk.type === 'url') {
          props.url = this.item.urls.find(u => u.href === chunk.text)
        } 

        nodes.push(createElement(elm, {
          props
        }, chunk.text
        ))
      })

    } else {
      // NOTE: this is a super crude catchall for old notes -- very few member if any will encounter
      // fixed on a save to the note
      nodes.push(createElement('span', {
        props: {}
      }, this.text))
    }

    return createElement(
      'pre',
      {
        class: {
          'line-through': this.strikethrough,
          'note font-mono': true},
        attrs: {}
      },
      nodes
    )
  },
  props: {
    text: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    strikethrough: {
      type: Boolean,
      default: false
    }
  }
})
